import React from 'react';
import type { ReactNode } from 'react';
import { type AccessUser } from '../../../types/access';
import { RoleBadge } from '../RoleBadge/RoleBadge';
import { RowActions } from '../RowActions/RowActions';
import styles from './UsersTable.module.scss';
import { DataTable, tableStyles } from '../../ui/DataTable/DataTable';

interface UsersTableProps {
    users: AccessUser[];
    footer?: ReactNode;
    empty?: ReactNode;
    scrollKey?: string | number;
    loading?: boolean;
    isLoading?: boolean;
    loadingText?: string;
    onOpen: (user: AccessUser) => void;
    onEdit: (user: AccessUser) => void;
    onDelete: (user: AccessUser) => void;
}
export function UsersTable({ users, footer, empty, scrollKey, loading, isLoading, loadingText, onOpen, onEdit, onDelete }: UsersTableProps) {
    return (
        <DataTable
            static
            className={styles.table}
            colgroup={
                <colgroup>
                    <col style={{ width: '26%' }} />
                    <col style={{ width: '20%' }} />
                    <col style={{ width: '34%' }} />
                    <col style={{ width: '12%' }} />
                    <col style={{ width: 120 }} />
                </colgroup>
            }
            footer={footer}
            empty={empty}
            scrollKey={scrollKey}
            loading={loading}
            isLoading={isLoading}
            loadingText={loadingText}
        >
            <thead>
                <tr>
                    <th>ФИО</th>
                    <th>Email</th>
                    <th>Организация</th>
                    <th>Роль</th>
                    <th className={styles.actions} aria-label="Действия" />
                </tr>
            </thead>

            <tbody>
                {users.map((user) => (
                    <tr key={user.id}>
                        <td className={styles.name}>
                            <button type="button" className={styles.link} onClick={() => onEdit(user)}>
                                {user.fullName}
                            </button>
                        </td>

                        <td>
                            <a className={styles.mail} href={`mailto:${user.email}`}>
                                {user.email}
                            </a>
                        </td>

                        <td className={styles.organization}>
                            {user.organization ?? (
                                <span className={tableStyles.dash}>Организация не указана</span>
                            )}
                        </td>

                        <td>
                            <RoleBadge role={user.role} />
                        </td>

                        <td className={styles.actions}>
                            <RowActions
                                onOpen={() => onOpen(user)}
                                onEdit={() => onEdit(user)}
                                onDelete={() => onDelete(user)}
                            />
                        </td>
                    </tr>
                ))}
            </tbody>
        </DataTable>
    );
}